import React from 'react'
import { ErrorMessage, Form, Formik } from 'formik'
import { Form as BForm, Button, Col, Row } from '@themesberg/react-bootstrap'
import PortalFilter from '../../../../components/PortalFilter'
import ClientFilter from '../../../../components/ClientFilter'
import { sessionSettingsSchema } from '../schemas'
import useSessionSettings from '../hooks/useSessionSettings'

const SessionSettings = ({ hasLoginRestrictUpdateSettings }) => {
  const {
    selectedClient,
    setSelectedClient,
    selectedPortal,
    setSelectedPortal,
    getInitialValues,
    handleSubmit,
    isSessionSettingsActive,
    setIsSessionSettingsActive,
    adminDetails,
    isTenant
  } = useSessionSettings()

  // Define field groups
  const userFields = [
    { key: 'loginCount', label: 'User Login Limit' },
    { key: 'userSessionExpiry', label: 'User Session Expiry in Minutes' }
  ]

  const adminFields = [
    { key: 'adminSessionExpiry', label: 'Admin Session Expiry in Minutes' },
    ...(adminDetails?.SuperadminRole?.superRoleId == 1 ? [{ key: 'superadminSessionExpiry', label: 'Superadmin Session Expiry in Minutes' }] : [])
  ]

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={getInitialValues()}
        validationSchema={sessionSettingsSchema(isTenant, adminDetails?.SuperadminRole?.superRoleId === 1, isSessionSettingsActive)}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ values, handleChange, handleSubmit }) => (
          <Form className='align-items-center mt-4'>
            <Row className='d-flex flex-column'>

              {/* Admin Section */}
              {!isTenant && (
                <>
                  <h5 className='mb-3'>Admins Session Settings</h5>
                  {adminFields.map(({ key, label }) => (
                    <Row key={key} className='mb-3 d-flex align-items-center'>
                      <Col xs={8} md={4}>
                        <BForm.Label>{label}</BForm.Label>
                      </Col>
                      <Col>
                        <BForm.Control
                          type='number'
                          name={key}
                          value={values[key] ?? ''}
                          placeholder={`Enter ${label}`}
                          onChange={handleChange}
                          disabled={!hasLoginRestrictUpdateSettings}
                          style={{ maxWidth: '420px', minWidth: '220px' }}
                        />
                        <ErrorMessage component='div' name={key} className='text-danger' />
                      </Col>
                    </Row>
                  ))}
                </>
              )}

              {/* User/Player Section */}
              <div className='d-flex flex-row mt-4 mb-3'>
                <h5 className='me-4'>User/Player Session Settings</h5>
                <BForm.Switch
                  name='isSessionSettingsActive'
                  checked={isSessionSettingsActive}
                  onChange={() => setIsSessionSettingsActive(!isSessionSettingsActive)}
                  disabled={!hasLoginRestrictUpdateSettings}
                />
              </div>

              <Row>
                {!isTenant && (
                  <Col className='d-flex align-self-center mt-2 mb-4' lg={3}>
                    <ClientFilter
                      selectedClient={selectedClient}
                      setSelectedClient={setSelectedClient}
                      setSelectedPortal={setSelectedPortal}
                      label='Choose Tenant Owner'
                    />
                  </Col>
                )}
                {selectedClient && (
                  <Col className='d-flex align-self-center mt-2 mb-4' lg={3}>
                    <PortalFilter
                      selectedClient={selectedClient}
                      selectedPortal={selectedPortal}
                      setSelectedPortal={setSelectedPortal}
                      label='Choose Tenant'
                    />
                  </Col>
                )}
              </Row>
              {userFields.map(({ key, label }) => (
                <Row key={key} className='mb-3 d-flex align-items-center'>
                  <Col xs={8} md={4}>
                    <BForm.Label>{label}</BForm.Label>
                  </Col>
                  <Col>
                    <BForm.Control
                      type='number'
                      name={key}
                      value={values[key] ?? ''}
                      placeholder={`Enter ${label}`}
                      onChange={handleChange}
                      disabled={!hasLoginRestrictUpdateSettings || !(isSessionSettingsActive && (isTenant || selectedPortal))}
                      style={{ maxWidth: '420px', minWidth: '220px' }}
                    />
                    <ErrorMessage component='div' name={key} className='text-danger' />
                  </Col>
                </Row>
              ))}

            </Row>

            <div className='mt-4 d-flex justify-content-center'>
              <Button
                variant='outline-success'
                onClick={handleSubmit}
                disabled={!hasLoginRestrictUpdateSettings}
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default SessionSettings
